import { IDetailInfoDataHttp } from 'common/model/common.model';
import { DetailGroupInfo, DetailInfo, IDetailGroupInfo, IDetailInfo, IDetailValue, IGridCanInfo, IRuleParemeters } from 'common/model';



export interface IQuestionnaireItemSaveRequestHttp {
  detailData: Array<IDetailInfoDataHttp>;
  projectId: number;
  activityGuid?: string;
  contactGuid?: string;
  evideInputContentFormGuid: string;
  programGuid?: string,
  questionnaireItemGuid: string,
  selectedVariantGuid?: string | null;
}

export interface IQuestionnaireSaveRequestHttp {
  itemAnswers: Array<IQuestionnaireItemSaveRequestHttp>;
  encodedResponse?: string;
}

// Shape mirrors EvideInputContentFormVariantInfo on the server.
export interface IQuestionnaireFormVariant {
  id: number;
  variantGuid: string;
  title: string;
  description: string;
  sortOrder: number;
  isDefault: boolean;
}

export interface IQuestionnaireResponseHttp {
  contactGuid: string,
  questionnaireItemGuid: string,
  canInfo: IQuestionnaireCanInfo,
  scheduleTitle: string,
  projectId: number;
  evideInputContentFormGuid: string;
  groupInfos: IDetailGroupInfo[];
  detailData: IDetailValue[];
  ruleParemeters: IRuleParemeters;
  variants?: IQuestionnaireFormVariant[];
  selectedVariantGuid?: string | null;
}

interface IQuestionnaireCanInfo {
  canDelete: boolean,
  canEdit: boolean
}



export class QuestionnaireInfo {

  constructor(
    public readonly contactGuid: string,
    public readonly questionnaireItemGuid: string,
    public readonly scheduleTitle: string,
    public readonly programDetailValue: IDetailValue[],
    public readonly groupInfos: Array<DetailGroupInfo>,
    public readonly evideInputContentFormGuid: string,
    public readonly projectId: number,
    public readonly ruleParemeters: IRuleParemeters,
    public readonly canInfo: IQuestionnaireCanInfo,
    public readonly variants: IQuestionnaireFormVariant[] = [],
    public readonly selectedVariantGuid: string | null = null
  ) { }

  public static fromJson(data: IQuestionnaireResponseHttp): QuestionnaireInfo {
    return new this(
      data.contactGuid, data.questionnaireItemGuid, data.scheduleTitle, data.detailData,
      data.groupInfos.map(item => DetailGroupInfo.fromJson(item, data.ruleParemeters)),
      data.evideInputContentFormGuid, data.projectId, data.ruleParemeters, data.canInfo,
      data.variants ?? [], data.selectedVariantGuid ?? null
    )
  }
}

export interface IQuestionnaireContactResponseHttp {
  projectId: number;
  formGuid: string;
  activitySessionGuid: string;
  questionnaireContactInfos: IQuestionnaireContactInfo[];
  gridRows: IQuestionnaireGridRow[];
}

export interface IQuestionnaireContactInfo {
  evideInputContentGuid: string,
  shortTitle: string,
  gridOrder: number,
  filterVisible: boolean,
  detailInfo: IDetailInfo | null;
}

export interface IQuestionnaireGridRow {
  contactGuid: string,
  questionnaireContactGridDatas: IQuestionnaireContactGridData[],
  ruleParemeters: IRuleParemeters
}

export interface IQuestionnaireContactGridData {
  evideInputContentGuid: string,
  dataStringGridValue: string
}

export class QuestionnaireContact {

  public detailInfo: DetailInfo;
  public gridOrder: number;

  constructor(
    public readonly evideInputContentGuid: string,
    public readonly dataStringGridValue: string,
  ) { }

  public static fromJson(data: IQuestionnaireContactGridData) {
    return new this(data.evideInputContentGuid, data.dataStringGridValue)
  }
}


export class QuestionnaireGridRow {

  constructor(
    public readonly uuid: string,
    public readonly contactGuid: string,
    public readonly questionnaireContacts: QuestionnaireContact[],
    public readonly ruleParemeters: IRuleParemeters,
  ) { }

  public static fromJson(data: IQuestionnaireGridRow) {
    return new this(
      `${DetailGroupInfo.KeyInitials}-${data.contactGuid}`,
      data.contactGuid,
      data.questionnaireContactGridDatas.map(item => QuestionnaireContact.fromJson(item)),
      data.ruleParemeters)
  }
}


export class QuestionnaireContactDetail {

  constructor(
    public readonly projectId: number,
    public readonly formGuid: string,
    public readonly activitySessionGuid: string,
    public readonly questionnaireContactInfos: QuestionnaireContactInfo[],
    public readonly gridRows: QuestionnaireGridRow[]
  ) { }

  public static fromJson(data: IQuestionnaireContactResponseHttp) {
    return new QuestionnaireContactDetail(
      data.projectId, data.formGuid, data.activitySessionGuid,
      data.questionnaireContactInfos.map(item => QuestionnaireContactInfo.fromJson(item)),
      data.gridRows.map(item => QuestionnaireGridRow.fromJson(item))
    )
  }
}

export class QuestionnaireContactInfo {

  constructor(
    public readonly evideInputContentGuid: string,
    public readonly shortTitle: string,
    public readonly gridOrder: number,
    public readonly filterVisible: boolean,
    public readonly detailInfo: DetailInfo
  ) { }

  public static fromJson(data: IQuestionnaireContactInfo) {
    return new QuestionnaireContactInfo(
      data.evideInputContentGuid, data.shortTitle, data.gridOrder, data.filterVisible,
      data.detailInfo ? DetailInfo.fromJson(data.detailInfo) : null
    )
  }
}